<template>
  <div id="user-list">
    <!-- app drawer -->
    <v-dialog
      v-model="isFormActive"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 500 : '100%'"
    >
      <status-form
        v-model="item"
        :is-form-active="isFormActive"
        @refetch-data="fetchItems"
      >
        <template v-slot:form-title>
          <span
            class="font-weight-semibold text-base text--primary">{{ item.id ? $t('Modifier') : $t('Ajouter un Statut')
            }}</span>
          <v-spacer />
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isFormActive = !isFormActive"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </template>
        <template #form-cancel>
          <v-btn
            :loading="loading"
            color="secondary"
            outlined
            type="reset"
            @click="isFormActive = !isFormActive"
          >
            {{ $t('Annuler') }}
          </v-btn>
        </template>
      </status-form>
    </v-dialog>
    <!-- status total card -->

    <!-- list filters -->
    <v-card>
      <v-card-title>
        {{ $t('Statuts') }}
        <v-chip outlined class="ml-2">{{ totalItems }}</v-chip>
      </v-card-title>
      <v-divider class="mt-4"></v-divider>

      <!-- actions -->
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <!-- search -->
        <v-row class="pt-5">
          <v-col
            cols="12"
            md="4"
            sm="6"
            xs="12"
          >
            <v-text-field
              v-model="searchQuery"
              :placeholder="$t('Rechercher')"
              outlined
              hide-details
              dense
              class="user-search me-3 mb-4"
            >
            </v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="4"
            sm="6"
            xs="12"
          >
            <v-select
              v-model="selectedItem"
              outlined
              dense
              :label="$t('Type')"
              :placeholder="$t('Type')"
              :items="[{id: '', label: 'Tous'},{id: 'publication', label: 'Publication'},{id: 'manuscript', label: 'Manuscrit'},]"
              item-value="id"
              item-text="label"
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            md="4"
            sm="6"
            xs="12"
          >
            <v-select
              v-model="selectedStatus"
              outlined
              dense
              :label="$t('Status')"
              :placeholder="$t('Status')"
              :items="[{id: '', label: 'Tous'},{id: 1, label: 'Activé'},{id: 0, label: 'Désactivé'},]"
              item-value="id"
              item-text="label"
              hide-details="auto"
            ></v-select>
          </v-col>
        </v-row>
        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            color="primary"
            class="mb-4 me-3"
            @click.stop="openDialog(false)"
          >
            <v-icon>{{ icons.mdiPlus }}</v-icon>
            <span>{{ $t('Ajouter un Statut') }}</span>
          </v-btn>

          <!--          <v-btn
            color="secondary"
            outlined
            class="mb-4"
          >
            <v-icon
              size="17"
              class="me-1"
            >
              {{ icons.mdiExportVariant }}
            </v-icon>
            <span>Export</span>
          </v-btn>-->
        </div>
      </v-card-text>

      <!-- table -->
      <v-data-table
        v-model="selectedRows"
        class="fixed-table"
        dense
        :headers="tableColumns"
        :items="items"
        :options.sync="options"
        :page.sync="page"
        :server-items-length="totalItems"
        :loading="loading"
        hide-default-footer
        show-select
        :loading-text="$t('Chargement des éléments')"
        :no-data-text="$t('Pas de données')"
        :no-results-text="$t('Aucun résultat')"
        @page-count="pageCount = $event"
      >
        <!-- actions -->
        <template #[`item.actions`]="{item}">
          <v-btn
            icon
            small
          >
            <v-icon
              size="20"
              @click="openDialog(item)"
            >
              {{ icons.mdiPencilOutline }}
            </v-icon>
          </v-btn>
          <v-btn
            v-if="$can('delete','Status')"
            icon
            small
            color="error"
          >
            <v-icon
              size="20"
              color="error"
              @click="deleteItem(item)"
            >
              {{ icons.mdiDeleteOutline }}
            </v-icon>
          </v-btn>
        </template>
        <template #[`item.status`]="{item}">
          <v-chip
            :color="getChipColor(item.status)"
            :class="`${getChipColor(item.status)}--text`"
            class="v-chip-light-bg font-weight-semibold text-capitalize"
            small
          >
            {{ getStatus(item.status) }}
          </v-chip>
        </template>
      </v-data-table>
      <v-card-text class="pt-2">
        <v-row>
          <v-col
            lg="2"
            cols="3"
          >
            <rows-per-page :options="options" />
          </v-col>

          <v-col
            lg="10"
            cols="9"
            class="d-flex justify-end"
          >
            <v-pagination
              v-model="page"
              total-visible="6"
              :length="pageCount"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-snackbar
      v-model="isSnackbarBottomVisible"
      :color="$vuetify.theme.currentTheme.error"
      :light="$vuetify.theme.dark"
    >
      {{ snackBarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiSquareEditOutline,
  mdiDotsVertical,
  mdiPlus,
  mdiClose,
  mdiFileDocumentOutline,
  mdiDeleteOutline,
  mdiExportVariant,
  mdiAccountOutline,
  mdiPencilOutline,
} from '@mdi/js'
import { onUnmounted } from '@vue/composition-api'

// sidebar
import { avatarText } from '@core/utils/filter'
import store from '@/store'
import StatusForm from './StatusForm.vue'
import userStoreModule from './itemStoreModule'

import controller from './Controller'
import RowsPerPage from '@/components/RowsPerPage'
import UserStatusChip from '@/views/apps/user/user-list/UserStatusChip.vue'

export default {
  components: {
    UserStatusChip,
    RowsPerPage,
    StatusForm,
  },
  setup() {
    const APP_STORE_MODULE_NAME = 'status'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      { title: 'Actif', value: 1 },
      { title: 'Inactif', value: 0 },
    ]

    const {
      item,
      items,
      tableColumns,
      searchQuery,
      selectedStatus,
      getChipColor,
      getStatus,
      totalItems,
      loading,
      options,
      selectedRows,
      selectedItem,
      isFormActive,
      snackBarMessage,
      isSnackbarBottomVisible,
      openDialog,
      deleteItem,
      fetchItems,
    } = controller()

    return {
      item,
      items,
      tableColumns,
      searchQuery,
      selectedStatus,
      getChipColor,
      getStatus,
      totalItems,
      loading,
      options,
      statusOptions,
      isFormActive,
      selectedRows,
      selectedItem,
      snackBarMessage,
      isSnackbarBottomVisible,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      openDialog,
      deleteItem,
      avatarText,
      fetchItems,

      // icons
      icons: {
        mdiSquareEditOutline,
        mdiFileDocumentOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPlus,
        mdiClose,
        mdiExportVariant,
        mdiAccountOutline,
        mdiPencilOutline,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
